
export const SUCCESS_MESSAGE_CLEAR = 'SUCCESS_MESSAGE_CLEAR'
export const ERROR_CLEAR = 'ERROR_CLEAR'

export const SETTING_UPDATE_SUCCESS = 'SETTING_UPDATE_SUCCESS'
export const SETTING_UPDATE_FAIL = 'SETTING_UPDATE_FAIL'

export const SETTING_GET_SUCCESS = 'SETTING_GET_SUCCESS'
export const SETTING_GET_FAIL = 'SETTING_GET_FAIL'

export const TEST_MAIL_SUCCESS = 'TEST_MAIL_SUCCESS'
export const TEST_MAIL_FAIL = 'TEST_MAIL_FAIL'

export const TEST_OTP_SUCCESS = "TEST_OTP_SUCCESS";
export const TEST_OTP_FAIL = "TEST_OTP_FAIL";
export const GET_2FA_SETTINGS_SUCCESS = "GET_2FA_SETTINGS_SUCCESS";
export const GET_2FA_SETTINGS_FAIL = "GET_2FA_SETTINGS_FAIL";
export const UPDATE_2FA_SETTINGS_SUCCESS = "UPDATE_2FA_SETTINGS_SUCCESS";
export const UPDATE_2FA_SETTINGS_FAIL = "UPDATE_2FA_SETTINGS_FAIL";
export const TOGGLE_2FA_USER_SUCCESS = "TOGGLE_2FA_USER_SUCCESS";
export const TOGGLE_2FA_USER_FAIL = "TOGGLE_2FA_USER_FAIL";